import { createSlice } from "@reduxjs/toolkit";

export const initialData = {
  finalAnswer: "",
  addfinalanswerLoading:null
};

const agentcanvaReducer = createSlice({
  name: "agentcanva",
  initialState: initialData,
  reducers: {
    addfinalanswerFun: (state, action) => {
      state.finalAnswer = action.payload;
    },
    addfinalanswerLoadingFun: (state, action) => {
        state.addfinalanswerLoading = action.payload;
      },
  },
});

export const { addfinalanswerFun,addfinalanswerLoadingFun } = agentcanvaReducer.actions;
export default agentcanvaReducer.reducer;
